import { useQuery } from '@tanstack/react-query';
import {
  fetchAllOnboardingConfigs,
  fetchOnboardingConfig,
  type OnboardingConfig,
  type OnboardingSlot,
} from '@/services/onboardingConfig';

export const ONBOARDING_CONFIG_KEY = 'onboarding-config';

export function useOnboardingConfig(slot: OnboardingSlot) {
  return useQuery<OnboardingConfig | null>({
    queryKey: [ONBOARDING_CONFIG_KEY, slot],
    queryFn: () => fetchOnboardingConfig(slot),
    staleTime: 10 * 60_000,
  });
}

export function useAllOnboardingConfigs() {
  return useQuery<OnboardingConfig[]>({
    queryKey: [ONBOARDING_CONFIG_KEY, 'all'],
    queryFn: fetchAllOnboardingConfigs,
    staleTime: 10 * 60_000,
  });
}